export const ARTICLEELEMENT_NODEDATA_BASKETID = "cf:basketId";
export const ARTICLEELEMENT_NODEDATA_SELECTABLE = "cf:selectable";
